import { ConfigField } from '@gantt/components/GanttCreateOrEdit'

// Matches field names before RSQL operators: ==, !=, =word=, >=, <=, >, <
const RSQL_FIELD_RE = /([a-zA-Z_][a-zA-Z0-9_.]*)\s*(?:==|!=|=[a-zA-Z]+=|>=|<=|>|<)/g

export function parseRsqlFields(rsql: string): ConfigField[] {
  if (!rsql?.trim()) return []

  const seen = new Set<string>()
  const result: ConfigField[] = []

  for (const match of rsql.matchAll(RSQL_FIELD_RE)) {
    const pathStr = match[1]
    if (seen.has(pathStr)) continue
    seen.add(pathStr)

    result.push({
      field: pathStr.replace(/\./g, '_'),
      pathStr,
      pathArray: [],
      isSystem: true,
    })
  }

  return result
}
